import { Ellipsoid } from "../geodesy/geodesy.ellipsoid";
import { Scalar } from "../math/math";
import { Cartesian2 } from "../geometry/geometry.cartesian";
export class Projections {
    static LatLonToWebMercator(lat, lon, ellipsoid) {
        return Projections.LatLonToWebMercatorToRef(lat, lon, Cartesian2.Zero(), ellipsoid);
    }
    static LatLonToWebMercatorToRef(lat, lon, ref, ellipsoid) {
        ellipsoid = ellipsoid || Ellipsoid.WGS84;
        ref.x = lon * Scalar.DEG2RAD * ellipsoid.semiMajorAxis;
        lat = Scalar.Clamp(lat, Projections.WebMercatorMinLatitude, Projections.WebMercatorMaxLatitude);
        let rad = lat * Scalar.DEG2RAD;
        ref.y = ellipsoid.semiMajorAxis * Math.log(Math.tan(Scalar.PI_4 + rad / 2));
        return ref;
    }
}
Projections.WebMercatorMaxLatitude = 85.05112878;
Projections.WebMercatorMinLatitude = -Projections.WebMercatorMaxLatitude;
//# sourceMappingURL=geography.projections.js.map